// MA-289 slice (b) — email/magic-link sign-in is gated behind a build-time
// flag because enabling it requires a founder action this loop cannot take
// (flip the Email provider on in the Supabase dashboard + confirm SMTP
// limits — see docs/ops/FOUNDER-FYI.md). The flag defaults OFF: unset =
// invisible, matching every other optional VITE_* flag in this repo
// (VITE_SENTRY_DSN, VITE_VERCEL_ENV).
//
// A dev-only preview override lets the real UI states (form/sending/sent/
// error) be exercised in e2e without needing the flag flipped in a real
// build — gated on import.meta.env.DEV so it compiles out of production
// exactly like the ?dev=1 auth bypass in useAuth.js.
//
// `typeof import.meta !== "undefined"` guard mirrors the established
// pattern in src/App/consentGate.js — import.meta.env is undefined under
// the node/tsx test runner (see src/lib/__tests__/sentry.test.mjs's own
// documented limit), so this function accepts an injectable `env` override
// to stay unit-testable without a real Vite runtime.
type EmailAuthEnv = { dev?: boolean; enabled?: string };

function readViteEnv(): EmailAuthEnv {
  const env =
    typeof import.meta !== "undefined"
      ? (import.meta as unknown as { env?: Record<string, unknown> }).env
      : undefined;
  return {
    dev: env?.DEV === true,
    enabled: typeof env?.VITE_EMAIL_AUTH_ENABLED === "string" ? env.VITE_EMAIL_AUTH_ENABLED : undefined,
  };
}

/**
 * previewParam: the raw `?emailAuthPreview=` search-param value (or null).
 * env: injectable for tests; defaults to the real Vite env at call time.
 */
export function isEmailAuthEnabled(
  previewParam?: string | null,
  env: EmailAuthEnv = readViteEnv(),
): boolean {
  if (env.dev && previewParam === "1") return true;
  return env.enabled === "true";
}
